/* eslint-disable react/destructuring-assignment */
import React, { useContext, useState } from "react";
import { string, instanceOf, bool, func } from "prop-types";
import { TransactionContext } from "pages/_components/TransactionCard/TransactionContext";
import * as i18n from "util/i18n";
import moment from "moment";
import FormattedAmount from "pages/_components/FormattedAmount";
import CustomData from "pages/_components/CustomData/CustomData";
import Button from "pages/_components/Button";
import { TransactionSign } from "pages/_components/TransactionCard";
import GridTable from "pages/_components/GridTable/GridTable";

const TransmitCedipSummaryBody = (props) => {
    const { transaction = {} } = useContext(TransactionContext);
    const [buttonLabel, setButtonLabel] = useState("echecks.seeMore.button");
    const { data = {}, creationDateTime = moment(), idTransaction = "" } = transaction;
    const {
        beneficiary,
        echeqsToEmit = props.echeqsToEmit,
        mode = props.mode,
        character = props.character,
        motive = props.motive,
        amount,
        environmentCuit = "",
        tipoTransmision,
        selectedCedip,
        ticket = props.ticket,
        showMoreData = props.showMoreData,
        setShowMoreData = props.setShowMoreData,
        isDesktop = props.isDesktop,
    } = data;
    const { document, reference } = beneficiary;
    const amountTicket = amount;

    const beneficiaryArr = document?.split(" ");
    const beneficiaryCuit = beneficiaryArr && beneficiaryArr[1];

    const numberCedip = `···${selectedCedip?.numeroCertificado?.slice(-6)}`;

    const handleSeeMoreData = () => {
        setShowMoreData(!showMoreData);
        if (!showMoreData) {
            setButtonLabel("echecks.seeLess.button");
        } else {
            setButtonLabel("echecks.seeMore.button");
        }
    };
    if (ticket) {
        return (
            <>
                <div className="ticket__body">
                    <div className="ticket-header-info">
                        {/* <CustomData
                                dataClass=""
                                titleText="cedip.ticket.account.label"
                                titleTextType="I18N"
                                valueText={emisionFormated}
                            /> */}
                        <CustomData
                            dataClass=""
                            titleText="cedip.ticket.number.certificate.label"
                            titleTextType="I18N"
                            valueText={numberCedip}
                        />
                        <CustomData
                            dataClass="benefitiary"
                            titleText="cedip.ticket.cuit.label"
                            titleTextType="I18N"
                            valueText={beneficiaryCuit}
                        />
                    </div>
                    <div className="view-more-data-button" id="element-to-ignore">
                        <div className="ticket__divider inside-ticket__body">
                            <div className="ticket__notch ticket__notch--left"> </div>
                            <div className="ticket__notch ticket__notch--right"> </div>
                        </div>
                        <Button
                            aria-expanded={showMoreData ? "true" : "false"}
                            className="more-button no-print"
                            label={buttonLabel}
                            bsStyle="link"
                            onClick={handleSeeMoreData}
                            image={showMoreData ? "figma/icon/arrow-up.svg" : "figma/icon/arrow-down.svg"}
                        />
                    </div>
                    <div className={`view-more-data ${showMoreData ? "expand " : "collapse"}`}>
                        <h2>{i18n.get("cedip.ticket.more.data.label", "Datos adicionales")}</h2>
                        <CustomData
                            dataClass="benefitiary"
                            titleText="cedip.ticket.business.name"
                            titleTextType="I18N"
                            valueText={reference}
                        />
                        <CustomData
                            dataClass=""
                            titleText="cedip.ticket.amount"
                            titleTextType="I18N"
                            valueText={
                                <FormattedAmount
                                    className="data-label"
                                    currency={amountTicket.currency}
                                    quantity={amountTicket.quantity}
                                />
                            }
                        />
                        <CustomData
                            dataClass=""
                            titleText="cedip.ticket.transmission.type"
                            titleTextType="I18N"
                            valueText={i18n.get(`cedips.transmissions.type.${tipoTransmision}`)}
                        />

                        <TransactionSign
                            noDate
                            creationTime
                            isSmall
                            isFinished
                            hasSignatures
                            customText="forms.transaction.ticket.dateAndHour"
                            isDesktop={isDesktop}
                            showMoreData={showMoreData}
                        />
                    </div>
                </div>
            </>
        );
    }
    return (
        <GridTable className="form-summary echeq-emit">
            <GridTable.Container columns={5}>
                <GridTable.Data columnStart={1} columnWidth={3} rowStart={1}>
                    {idTransaction && (
                        <>
                            <CustomData
                                titleText="ticket.voucher"
                                titleTextType="I18N"
                                valueText={idTransaction.substring(0, 8).toUpperCase()}
                            />
                            <CustomData titleText="echecks.cuit" titleTextType="I18N" valueText={environmentCuit} />
                        </>
                    )}
                    {/* <CustomData
                        titleText="echecks.emit.emision.label"
                        titleTextType="I18N"
                        valueText={emisionFormated}
                    /> */}
                </GridTable.Data>
                <GridTable.Data columnStart={5} columnWidth={1} rowStart={1} alignX="flex-end">
                    <div className="tag tag-error">{character}</div>
                </GridTable.Data>

                <GridTable.Data columnStart={1} rowStart={2}>
                    <CustomData
                        titleText="echecks.createdRange.label"
                        titleTextType="I18N"
                        valueText={creationDateTime}
                        valueTextType="DATE"
                    />
                </GridTable.Data>
                <GridTable.Data columnStart={2} rowStart={2}>
                    <CustomData
                        titleText="echecks.payedRange.label"
                        titleTextType="I18N"
                        valueText={echeqsToEmit[0]?.date}
                        valueTextType="DATE"
                    />
                </GridTable.Data>
                <GridTable.Data columnStart={3} rowStart={2}>
                    <CustomData titleText="echecks.emit.mode" titleTextType="I18N" valueText={mode} />
                </GridTable.Data>
                <GridTable.Data columnStart={2} rowStart={3}>
                    <CustomData
                        titleText="echecks.emit.motive.label"
                        titleTextType="I18N"
                        valueText={motive || "-"}
                        valueTextType="TEXT"
                    />
                </GridTable.Data>
                <GridTable.Data columnStart={3} rowStart={3}>
                    <CustomData
                        titleText="echecks.emit.reference.label"
                        titleTextType="I18N"
                        valueText={echeqsToEmit[0]?.reference || "-"}
                        valueTextType="TEXT"
                    />
                </GridTable.Data>
                <GridTable.Data
                    columnStart={4}
                    columnWidth={1}
                    rowStart={1}
                    rowWidth={3}
                    alignX="center"
                    className="vertical-divider">
                    {" "}
                </GridTable.Data>
                <GridTable.Data columnStart={5} rowStart={2} alignX="flex-end">
                    <CustomData
                        titleText="echecks.echeckType"
                        titleTextType="I18N"
                        valueText={echeqsToEmit[0]?.type}
                        valueTextType="TEXT"
                    />
                </GridTable.Data>
                <GridTable.Data columnStart={5} rowStart={3} alignX="flex-end">
                    <CustomData
                        titleText="echecks.amount"
                        titleTextType="I18N"
                        valueText={
                            <FormattedAmount
                                className="data-label"
                                currency={amount.currency}
                                quantity={echeqsToEmit[0]?.amount}
                            />
                        }
                    />
                </GridTable.Data>
                <GridTable.Data columnStart={1} columnWidth={5} rowStart={4} className="my-6 horizontal-divider">
                    {" "}
                </GridTable.Data>

                <GridTable.Data columnStart={1} rowStart={6} columnWidth={4}>
                    <h2>{i18n.get("echecks.beneficiary")}</h2>
                </GridTable.Data>
                <GridTable.Data columnStart={1} rowStart={7} columnWidth={2}>
                    <CustomData titleText="echecks.beneficiary" titleTextType="I18N" valueText={reference} />
                </GridTable.Data>
                <GridTable.Data columnStart={3} rowStart={7} columnWidth={2}>
                    <CustomData titleText="echecks.document" titleTextType="I18N" valueText={beneficiary} />
                </GridTable.Data>
            </GridTable.Container>
        </GridTable>
    );
};

TransmitCedipSummaryBody.propTypes = {
    echeqsToEmit: instanceOf(Array),
    mode: string,
    character: string,
    motive: string,
    ticket: bool,
    showMoreData: bool,
    isDesktop: bool,
    setShowMoreData: func,
};

TransmitCedipSummaryBody.defaultProps = {
    echeqsToEmit: [],
    mode: "",
    character: "",
    motive: "-",
    ticket: false,
    showMoreData: false,
    isDesktop: false,
    setShowMoreData: () => {},
};

export default TransmitCedipSummaryBody;
